import { render } from "./not-authorized.vue?vue&type=template&id=0c751d36&scoped=true"
import script from "./not-authorized.vue?vue&type=script&lang=js"
export * from "./not-authorized.vue?vue&type=script&lang=js"

import "./not-authorized.vue?vue&type=style&index=0&id=0c751d36&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c751d36"]])

export default __exports__